import React from 'react';
import './Hooks.scss';

const Hooks = () => {
  
  return (

    <div className="main-right-side-section">
      <div className="hooks-main-section">
        <section>
          <div className="hooks-section-1">
            <div className="hooks-section-1-inner">
              <p>Hooks Component</p>
            </div>
          </div>
        </section>
      </div>
    </div>

  );
}

Hooks.propTypes = {};

Hooks.defaultProps = {};

export default Hooks;
